import React, { useState, useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';


import loading from '../img/loading.svg';
import pdf from "../img/pdf.jpg"


const Uploadwill = ({files, setFiles, id, name}) => {

  let isUploading = false;

  const props = {
    action: `${process.env.REACT_APP_API}/upload3`,
    listType: 'picture',
    previewFile: (file) => { // Cambiado a función de flecha
        //console.log('Your upload file:', file);

        if (isUploading) {
          //console.log('Ya se está subiendo un archivo.'); // Mensaje de depuración
          return; // Salir si ya se está subiendo un archivo
      }

        // Supongamos que tienes un número que deseas enviar
        const number = 42; // Cambia esto por el número que necesites

      
 
        const formData = new FormData();
        formData.append('file', file);
        formData.append('number', number);

        return fetch(props.action, { // Usa props.action directamente
            method: 'POST',
            body: formData,
        })
        .then((res) => res.json())
        .then(({ thumbnail }) => thumbnail)
        .catch((error) => {
            console.error('Error:', error);
        });
    },
};


    const [datos, setDatos]  = useState([{
		nombres: "",
		estatus: "",
        telefono: "",
        email: "",
	}]);


    const [archivos, setArchivos] = useState(files)

    const [cargandoarchivo, setCargandoarchivo] = useState(false)
    const [file2, setFile2] = useState(null);
  


 const handleFileChange2 = (event) => {
      

  const file = event.target.files[0];
      

  // if (file.type !== 'image/png' && file.type !== 'image/jpeg' ) { 
  //   msjsave('Seleccione un archivo de imagen PNG o JPEG.', "warning"); 
  //   return ; 
  //   } 
  
    if (file.size > 25 * 1024 * 1024) { 
    console.log('El tamaño del archivo no debe superar 25 MB.',"warning"); 
    return; 
  }
  //console.log(file)
  setFile2(file);
  setCargandoarchivo(true)


  };


    const adjuntararchiv = () => {
      //console.log("ejecutando")

      const formData = new FormData();
  formData.append('file', file2);
  fetch(`${process.env.REACT_APP_API}/adjuntararchiv`, {
      method: 'POST',
      body: formData
  })
  .then(response => {
      if (!response.ok) {
          throw new Error('Error en la carga del archivo');
      }
      return response.text(); // O response.json() si esperas un JSON
  })
  .then(data => {

    const valor = JSON.parse(data);
    //console.log(valor)
    setArchivos([...archivos, valor])
    
  setCargandoarchivo(false)

  })
  .catch(error => {
      console.error('Error:', error); // Maneja cualquier error
  });

  }




    const eliminardocumento = (index) => {
      setArchivos(archivos.filter((_, i) => i !== index));
    }


const obtenertamano = (bytes) => {

  const MB = 1024 * 1024; // 1 MB = 1024 * 1024 bytes
    return (bytes / MB).toFixed(2);
}

const activarfile2 = () => {
  document.getElementById(id).click();
}

  useEffect(() => {
   console.log(archivos)
   setFiles(archivos)
  }, [archivos]);


  useEffect(() => {
    //console.log(datos)
  }, [datos]);

  useEffect(() => {
    
    //console.log(file2)
    if(file2 != null){
      adjuntararchiv()
    }
    
  }, [file2]);

  return (
    <><div>
        <input type="file" onChange={handleFileChange2} accept=".jpg, .jpeg, .png, .doc, .xls, .pdf, .docx, .xlsx" style={{display: 'none'}} id={id} />
                      {cargandoarchivo == false ? (<button type="button" style={{backgroundColor: '#5e72e4', color: 'white'}} onClick={() => {
                      activarfile2();
                      }} class="btn app-btn-secondary" ><svg class="w-6 h-6 text-[#FE2A9F]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z" clip-rule="evenodd"/>
  <path fill-rule="evenodd" d="M15.026 21.534A9.994 9.994 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c2.51 0 4.802.924 6.558 2.45l-7.635 7.636L7.707 8.87a1 1 0 0 0-1.414 1.414l3.923 3.923a1 1 0 0 0 1.414 0l8.3-8.3A9.956 9.956 0 0 1 22 12a9.994 9.994 0 0 1-.466 3.026A2.49 2.49 0 0 0 20 14.5h-.5V14a2.5 2.5 0 0 0-5 0v.5H14a2.5 2.5 0 0 0 0 5h.5v.5c0 .578.196 1.11.526 1.534Z" clip-rule="evenodd"/>
</svg>
 &nbsp;
 Subir {name}</button>) : (<button type="button" style={{backgroundColor: '#5e72e4', color: 'white'}} onClick={() => {
  activarfile2();
  }} class="btn app-btn-secondary" ><img src={loading} alt="" />
&nbsp;
Cargando Archivo...</button>)}
                      </div>
                      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap',}}>
                      {archivos.map((val, key) => {
  return (
    <>
      {val.type === 'image/png' || val.type === 'image/jpeg' ? (
        <div
          key={key}
          style={{
            padding: '2px',
            position: 'relative',
            display: 'inline-block' // Para que las imágenes se acomoden como bloques
          }}
        >
          <img
            src={`${process.env.REACT_APP_API}/${val.ruta}`}
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: '10px'
            }}
            alt="imagen"
          />

          <div
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              zIndex: 2,
              cursor: 'pointer'
            }}
          >
            <svg class="w-6 h-6" onClick={() => {
            eliminardocumento(key);
            }} style={{color: 'white', cursor: 'pointer'}} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z" clip-rule="evenodd"/>
</svg>

          </div>
        </div>
      ) : (
        <div
          key={key}
          style={{
            padding: '2px',
            position: 'relative',
            display: 'inline-block' // Para que las imágenes se acomoden como bloques
          }}
        >
          <img
            src={pdf}
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: '10px'
            }}
            alt="imagen"
          />

          <div
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              zIndex: 2,
              cursor: 'pointer'
            }}
          >
            <svg class="w-6 h-6" onClick={() => {
            eliminardocumento(key);
            }} style={{color: 'black', cursor: 'pointer'}} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z" clip-rule="evenodd"/>
</svg>

          </div>
        </div>
      )}
    </>
  );
})}



                        
                      </div>

                                      <hr class="my-1" />
                                      <ToastContainer /></>
  )
}

export default Uploadwill
